import { useState } from 'react';
import { FolderArchive, FileText, IdCard } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PiecesTab } from '../components/pieces-tab';
import { BlocksTab } from '../components/blocks-tab';
import { ProfileTab } from '../components/profile-tab';

/**
 * Sprint 5 v3 — Page « Dossier company » avec 3 onglets.
 */
export function DossierCompanyPage() {
  const [tab, setTab] = useState<'pieces' | 'blocks' | 'profile'>('pieces');

  return (
    <div className="container mx-auto py-6 space-y-6">
      <header>
        <h1 className="text-2xl font-semibold">Dossier company</h1>
        <p className="text-muted-foreground mt-1">
          Référentiel central des pièces administratives, blocs rédactionnels et profil structuré
          réutilisables sur tous les appels d'offres.
        </p>
      </header>

      <Tabs value={tab} onValueChange={(v) => setTab(v as typeof tab)}>
        <TabsList>
          <TabsTrigger value="pieces">
            <FolderArchive className="mr-2 h-4 w-4" />
            Pièces administratives
          </TabsTrigger>
          <TabsTrigger value="blocks">
            <FileText className="mr-2 h-4 w-4" />
            Contenus rédactionnels
          </TabsTrigger>
          <TabsTrigger value="profile">
            <IdCard className="mr-2 h-4 w-4" />
            Profil
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pieces" className="mt-6">
          <PiecesTab />
        </TabsContent>
        <TabsContent value="blocks" className="mt-6">
          <BlocksTab />
        </TabsContent>
        <TabsContent value="profile" className="mt-6">
          <ProfileTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
